import api from "@/lib/api";

// "MFG" spoken chime for in-app notifications. Browsers only allow audio after a
// user gesture, so we unlock on the first tap/click and keep one Audio element per voice warm.
const BASE = process.env.REACT_APP_BACKEND_URL;
let prefs = { enabled: true, voice: "male", phrase: "mfg", volume: 0.8, quiet_now: false };
let prefsAt = 0;
let unlocked = false;
const players = {};
let lastPlay = 0;

const CHIME_VERSION = "5"; // bump when the clip is regenerated (URL is long-cached)
export const chimeUrl = (voice, phrase = "mfg") => `${BASE}/api/chimes/${phrase}/${voice}.wav?v=${CHIME_VERSION}`;

const player = (voice, phrase = "mfg") => {
  const k = `${phrase}/${voice}`;
  if (!players[k]) {
    const a = new Audio(chimeUrl(voice, phrase));
    a.preload = "auto";
    players[k] = a;
  }
  return players[k];
};

export const refreshChimePrefs = async () => {
  try {
    const { data } = await api.get("/me/alert-preferences");
    prefs = { ...(data.chime || {}), quiet_now: !!(data.quiet_now && data.quiet_hours?.enabled) };
    prefsAt = Date.now();
  } catch { /* keep last known */ }
  return prefs;
};

export const setChimePrefsLocal = (p) => { prefs = { ...prefs, ...p }; prefsAt = Date.now(); };

const ding = (volume) => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = "sine"; o.frequency.setValueAtTime(880, ctx.currentTime); o.frequency.setValueAtTime(1175, ctx.currentTime + 0.12);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(Math.max(volume, 0.01), ctx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.6);
    o.connect(g); g.connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.65);
    setTimeout(() => ctx.close(), 800);
  } catch { /* no audio */ }
};

// Play regardless of prefs (Settings "hear example").
export const previewChime = async (voice, volume = 0.8, phrase = "mfg") => {
  unlocked = true;
  if (voice === "ding") return ding(volume);
  const a = player(voice, phrase);
  a.volume = volume;
  // Wait until the whole clip is buffered so the first syllable isn't clipped on slow phones.
  if (a.readyState < 4) {
    await new Promise((res) => { const done = () => res(); a.addEventListener("canplaythrough", done, { once: true }); a.addEventListener("error", done, { once: true }); a.load(); setTimeout(done, 2500); });
  }
  a.currentTime = 0;
  await a.play();
};

// Play for a real notification: honours enabled / quiet hours / 2 s debounce.
export const playChime = async () => {
  if (Date.now() - prefsAt > 10 * 60 * 1000) await refreshChimePrefs();
  if (!prefs.enabled || prefs.quiet_now || !unlocked) return false;
  if (Date.now() - lastPlay < 2000) return false;
  lastPlay = Date.now();
  try { await previewChime(prefs.voice, prefs.volume, prefs.phrase || "mfg"); return true; } catch { return false; }
};

// Unlock audio on first gesture and pre-warm the chosen voice; relay chimes from the service worker (push while app is open).
export const installChime = () => {
  const unlock = () => {
    unlocked = true;
    if (prefs.voice !== "ding") { try { player(prefs.voice, prefs.phrase || "mfg").load(); } catch { /* ignore */ } }
    window.removeEventListener("pointerdown", unlock); window.removeEventListener("keydown", unlock);
  };
  window.addEventListener("pointerdown", unlock); window.addEventListener("keydown", unlock);
  refreshChimePrefs();
  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener("message", (e) => { if (e.data?.type === "mfg-chime") playChime(); });
  }
};
